/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_HelpInputs */

const en_reset_request_help = /** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the address you sign in with. We will send a link that sets a new password.`)
};

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const ar_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const he_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const ur_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const es_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const fr_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const de_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const pt_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const hi_reset_request_help = en_reset_request_help;

/** @type {(inputs: Reset_Request_HelpInputs) => LocalizedString} */
const bn_reset_request_help = en_reset_request_help;

/**
* | output |
* | --- |
* | "Enter the address you sign in with. We will send a link that sets a new password." |
*
* @param {Reset_Request_HelpInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_request_help = /** @type {((inputs?: Reset_Request_HelpInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_HelpInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_request_help(inputs)
	if (locale === "he") return he_reset_request_help(inputs)
	if (locale === "ur") return ur_reset_request_help(inputs)
	if (locale === "es") return es_reset_request_help(inputs)
	if (locale === "fr") return fr_reset_request_help(inputs)
	if (locale === "de") return de_reset_request_help(inputs)
	if (locale === "pt") return pt_reset_request_help(inputs)
	if (locale === "hi") return hi_reset_request_help(inputs)
	if (locale === "bn") return bn_reset_request_help(inputs)
	return /** @type {LocalizedString} */ ("Enter the address you sign in with. We will send a link that sets a new password.")
});